import {
  Additional,
  Responsive,
  Sort,
  TableContextReproducer,
} from '@apia/table';
import { Accordion, AccordionItem } from '@apia/components';
import { TableController } from '../../TableController';
import { Box } from '@apia/theme';
import { getLabel } from '@apia/util';

export const AdditionalFiltersComponent = ({
  tableController,
}: {
  tableController: TableController;
}) => {
  const filterTitle = getLabel('sbtFilters').text;
  const sortTitle = getLabel('titOrderBy').text;
  const filterTypes = getLabel('btnFilterType').text;
  return (
    <TableContextReproducer tableName={tableController.getTableName()}>
      <Box className="additionalFiltersContent">
        <Accordion>
          <AccordionItem
            id="Responsive"
            buttonProps={{ ariaLabel: filterTitle, label: filterTitle }}
          >
            <Responsive />
          </AccordionItem>
          <AccordionItem
            id="Additional"
            buttonProps={{ ariaLabel: sortTitle, label: sortTitle }}
          >
            <Additional />
          </AccordionItem>
          <AccordionItem
            id="Sort"
            buttonProps={{ ariaLabel: filterTypes, label: filterTypes }}
          >
            <Sort />
          </AccordionItem>
        </Accordion>
      </Box>
    </TableContextReproducer>
  );
};
